import { Component, type ErrorInfo, type ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

interface State {
  error: Error | null;
}

/**
 * Catches render errors so one broken screen does not blank the whole portal.
 * Deliberately shows the message rather than a friendly nothing: during Phase 2
 * the only people using this are the ones who can fix it.
 */
export class ErrorBoundary extends Component<Props, State> {
  override state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  override componentDidCatch(error: Error, info: ErrorInfo): void {
    console.error('portal render error', error, info.componentStack);
  }

  override render(): ReactNode {
    if (this.state.error) {
      return (
        <p className="state-note" data-tone="warn" role="alert">
          Something broke rendering this screen: {this.state.error.message}
        </p>
      );
    }
    return this.props.children;
  }
}
